import React from 'react'

import Button from '../form/Button'
import SendIcon from '../../../assets/icons/send.svg?react'

interface ChatTextInputProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void
  handleSubmitWithTranscription?: (transcription: string) => void
  icon?: React.ReactElement
  placeholder?: string
  bgColor?: string
  initialRows?: number
  buttonLabel?: string
  enableVoiceToText?: boolean
  sessionId?: string
  customButtons?: React.ReactElement | React.ReactElement[]
}

const ChatTextInput: React.FC<ChatTextInputProps> = ({
  value,
  onChange,
  bgColor = 'gray-300',
  handleSubmit,
  enableVoiceToText,
  initialRows = 1,
  buttonLabel,
  customButtons,
  ...props
}) => {
  const textareaRef = React.useRef<HTMLTextAreaElement>(null)

  React.useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
      const scrollHeight = textareaRef.current.scrollHeight
      // Set max height to 200px. Will add a scrollbar if it exceeds this height
      const newHeight = Math.min(scrollHeight, 200)
      textareaRef.current.style.height = `${newHeight}px`
    }
  }, [value])

  const TextArea = (
    !enableVoiceToText ? (
      <textarea
        rows={initialRows} ref={textareaRef}
        value={value} onChange={onChange}
        className={`
          w-full
          rounded-2xl
          resize-none
          py-2.5
          px-5
          placeholder:text-gray
          text-xs sm:text-sm
          outline-soft-green
          transition-height duration-200
          bg-${bgColor}
        `}
        {...props}
      />
    ) : null
  )
  return (
    <form
      onSubmit={handleSubmit}
      className='flex items-center gap-x-2 sm:p-1'
    >
      {
        buttonLabel ? (
          <div className='items-center w-full'>
            {TextArea}
            {customButtons || <Button className='mt-4'>{buttonLabel}</Button>}
          </div>
          ): (
            <div className='w-full'>
              <div className='flex items-center w-full gap-x-4'>
                {TextArea}
                {!enableVoiceToText && (
                  customButtons ||
                  <Button
                    variant='primary'
                    icon={<SendIcon stroke='white' />}
                    type='submit'
                    size='sm'
                  />
                )}
              </div>
            </div>
          )
      }
    </form>
  )
}

export default ChatTextInput
